
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from '@/components/ui/button';
import { Plus, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import ArticlesList from './ArticlesList';
import MediaLibrary from './MediaLibrary';
import BrandKit from './BrandKit';
import SitePages from './SitePages';

const ContentManagement = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <h2 className="text-2xl font-bold">Content Management</h2>
        
        <div className="flex gap-2 w-full sm:w-auto">
          <div className="relative flex-grow sm:flex-grow-0">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Search content..."
              className="pl-8 w-full sm:w-[200px]"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            New
          </Button>
        </div>
      </div>
      
      <Tabs defaultValue="articles" className="w-full">
        <TabsList className="mb-4 w-full justify-start border-b pb-0 overflow-x-auto">
          <TabsTrigger value="articles" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Articles
          </TabsTrigger>
          <TabsTrigger value="pages" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Pages
          </TabsTrigger>
          <TabsTrigger value="media" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Media
          </TabsTrigger>
          <TabsTrigger value="brand" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Brand Kit
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="articles" className="py-4">
          <ArticlesList searchQuery={searchQuery} />
        </TabsContent>
        
        <TabsContent value="pages" className="py-4">
          <SitePages searchQuery={searchQuery} />
        </TabsContent>
        
        <TabsContent value="media" className="py-4">
          <MediaLibrary searchQuery={searchQuery} />
        </TabsContent>
        
        <TabsContent value="brand" className="py-4">
          <BrandKit />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ContentManagement;
